import ReactRecord from './components/ReactRecord';

export default ReactRecord;